import { createBrowserRouter } from 'react-router-dom';
import { Suspense } from 'react';

import MainDashboard from '@pages/common/MainDashboard';
import Register from '@pages/common/Register';
import Login from '@pages/common/Login/Login';
import SkeletonWithAuth from '@components/SkeletonWithAuth';
import FileBrowser from '@pages/common/FileBrowser';
import { Project, Projects } from '@pages/common/Project';
import { Patients, Patient } from '@pages/common/Patient';
import AccountPage from '@pages/common/Account/AccountPage';
import BatchConfig from '@pages/common/Project/BatchConfig';
import ViewPipeline from '@pages/common/Administrator/Pipeline/components/ViewPipeline';
import PipelinesPage from '@pages/common/Administrator/Pipeline/PipelinesPage';
import ProjectEdit from '@pages/common/Project/ProjectEdit';
import ResetPasswordPage from './pages/common/Login/ResetPasswordPage';
import Samples from './pages/common/Sample/Samples';
import AdminPage from './pages/common/Administrator/AdminPage';
import PermissionsForm from './pages/common/Administrator/Permissions/PermissionForm';
import UserPage from './pages/common/Administrator/Users/UserPage';
import Result from './pages/common/Results/ResultPage';
import FlowgateResultsPage from './pages/common/Results/FlowgateResultsPage';
import FlowgateResultPage from './pages/common/Results/FlowgateResultPage';
import GenePanelLists from './pages/common/Administrator/GenePanel/GenePanelLists';
import GenePanel from './pages/common/Administrator/GenePanel/GenePanel';
import ProjectPreview from './pages/preview/ProjectPreview/ProjectPreview';

const router = createBrowserRouter([
  {
    path: '/preview/project',
    element: <ProjectPreview />,
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/password_reset/reset/:uniqId',
    element: <ResetPasswordPage />,
  },
  {
    path: '/register',
    element: <Register />,
  },
  {
    path: '/',
    element: <SkeletonWithAuth />,
    children: [
      {
        index: true,
        element: <MainDashboard />,
      },
      {
        path: 'patients',
        children: [
          {
            index: true,
            element: <Patients />,
          },
          {
            path: 'create',
            element: <Patient />,
          },
          {
            path: ':patientId',
            element: <Patient />,
          },
        ],
      },
      {
        path: 'samples',
        children: [
          {
            index: true,
            element: <Samples />,
          },
        ],
      },
      {
        path: 'files',
        element: <FileBrowser onClose={() => null} />,
      },
      {
        path: 'projects',
        children: [
          {
            index: true,
            element: <Projects />,
          },
          {
            path: 'create',
            element: <Project />,
          },
          {
            // Original
            path: ':projectId',
            element: <ProjectEdit />,
          },
        ],
      },
      {
        path: 'batch',
        children: [
          {
            index: true,
            element: <BatchConfig />,
          },
        ],
      },
      {
        path: 'account',
        children: [
          {
            index: true,
            element: <AccountPage />,
          },
        ],
      },
      {
        path: 'administrator',
        children: [
          {
            index: true,
            element: <AdminPage />,
          },
          {
            path: 'pipeline',
            element: <PipelinesPage />,
          },
          {
            path: 'pipeline/create',
            element: <ViewPipeline />,
          },
          {
            path: 'pipeline/:pipelineId',
            element: <ViewPipeline />,
          },
          {
            path: 'genepanel',
            element: <GenePanelLists />,
          },
          {
            path: 'genepanel/create',
            element: <GenePanel />,
          },
          {
            path: 'genepanel/:panelId',
            element: <GenePanel />,
          },
          {
            path: 'permission/group/create',
            element: <PermissionsForm />,
          },
          {
            path: 'permission/group/edit/:permissionId',
            element: <PermissionsForm />,
          },
          {
            path: 'user/edit/:userId',
            element: <UserPage />,
          },
        ],
      },
      {
        path: 'result/:outputID',
        children: [
          {
            index: true,
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <Result />
              </Suspense>
            ),
          },
        ],
      },
      {
        path: 'result/experiment/:experimentId',
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <FlowgateResultsPage />
          </Suspense>
        ),
      },
      {
        path: 'result/experiment/:experimentId/:resultId',
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <FlowgateResultPage />
          </Suspense>
        ),
      },
    ],
  },
]);

export default router;
